import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'

export default function Pricing() {
  return (
    <div className="et_pb_row">
      <div className="et_pb_column et_pb_column_1_4">
        <div className="et_pb_text et_pb_bg_layout_light et_pb_text_align_right" />
      </div>
      <div className="et_pb_column et_pb_column_1_2">
        <div className="et_pb_text et_pb_bg_layout_light et_pb_text_align_center">
          <h2>
            It’s free to make a basic will including executors, guardians, your
            estate and legal wishes
          </h2>
          <h2>To make as many specific gifts as you like costs just £50</h2>
          <p>
            If you need to pay you will <strong>only pay</strong> when you
            &nbsp;download your Will
            <br />
            <strong>Free</strong> updates for the rest of your life
          </p>
        </div>
        <div className="et_pb_promo et_pb_bg_layout_dark et_pb_text_align_center">
          <div className="et_pb_promo_description" />
          <a
            className="et_pb_promo_button"
            href="https://app.affio.co.uk/#/register"
          >
            Click here to Start Now
          </a>
        </div>
      </div>
      <div className="et_pb_column et_pb_column_1_4">
        <div className="et_pb_text et_pb_bg_layout_light et_pb_text_align_left">
          <StaticImage
            src="../../images/free-to-try.png"
            alt="Free to Try"
            className="alignleft size-full"
            width={150}
            objectFit="none"
          />
        </div>
      </div>
    </div>
  )
}
